// Function to filter diffStatus not UNCHANGED
export function filterDiffStatusNotUnchanged(data) {
  return data.filter((f) => f.diffStatus !== 'UNCHANGED')
}
